import { useState, useEffect } from 'react'
import { supabase } from '../config/supabase'
import { useAuth } from '../contexts/AuthContext'
import toast from 'react-hot-toast'

export const useEnrollments = () => {
  const { user } = useAuth()
  const [enrollments, setEnrollments] = useState([])
  const [loading, setLoading] = useState(true)
  const [isDemo, setIsDemo] = useState(false)

  useEffect(() => {
    if (user) {
      fetchEnrollments()
    } else {
      setEnrollments([])
      setLoading(false)
    }
  }, [user])

  const fetchEnrollments = async () => {
    try {
      const { data, error } = await supabase
        .from('enrollments')
        .select(`
          *,
          courses (*)
        `)
        .eq('user_id', user.id)
        .eq('status', 'active')

      if (error) {
        console.warn('Enrollments table not found, using demo mode')
        setIsDemo(true)
        setEnrollments([])
      } else {
        setIsDemo(false)
        setEnrollments(data || [])
      }
    } catch (error) {
      console.error('Error fetching enrollments:', error)
      setIsDemo(true)
      setEnrollments([])
    } finally {
      setLoading(false)
    }
  }

  const enrollInCourse = async (courseId) => {
    if (isDemo) {
      toast.success('Demo enrollment successful! In a real app, you would be enrolled in this course.')
      return { data: { id: 'demo-enrollment', course_id: courseId }, error: null }
    }

    try {
      const { data, error } = await supabase
        .from('enrollments')
        .insert([{
          user_id: user.id,
          course_id: courseId
        }])
        .select(`
          *,
          courses (*)
        `)
        .single()

      if (error) throw error

      setEnrollments(prev => [...prev, data])
      toast.success('Successfully enrolled in course!')
      return { data, error: null }
    } catch (error) {
      toast.error(error.message)
      return { data: null, error }
    }
  }

  const isEnrolled = (courseId) => {
    return enrollments.some(enrollment => enrollment.course_id === courseId)
  }

  return {
    enrollments,
    loading,
    isDemo,
    enrollInCourse,
    isEnrolled,
    refetch: fetchEnrollments
  }
}